import React, { useEffect, useState, useMemo } from "react";
import Breadcrumb from "../../../../Components/Breadcrumb/Breadcrumb";
import axios from "axios";
import EvnVar from "../../../../EnvVar";
import Cookies from "js-cookie";
import {
  MaterialReactTable,
  createMRTColumnHelper,
  useMaterialReactTable,
} from "material-react-table";
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { mkConfig, generateCsv, download } from "export-to-csv";
import VGMReportDetailsAPI from "../../../../Components/VGMReportDetailsAPI/VGMReportDetailsAPI";

function VGMReport() {
  const baseURL = EvnVar();
  const token = Cookies.get("jwt");
  const [data, setData] = useState([]);
  const [modalData, setModalData] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const dataFirstKey = useMemo(() => data[0], [data]);
  const reportDataKey = useMemo(
    () => (dataFirstKey ? Object.keys(dataFirstKey) : []),
    [dataFirstKey]
  );

  useEffect(() => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${baseURL}/user/vgmReport`,
      headers: {
        Authorization: token,
      },
      withCredentials: true,
    };
    axios
      .request(config)
      .then((response) => {
        setData(response.data); // Only set response data
      })
      .catch((error) => {
        console.error("Error making request:", error.message);
        if (error.response) {
          console.error("Error response:", error.response);
        } else if (error.request) {
          console.error("Error request:", error.request);
        }
      });
  }, [baseURL, token]);

  const columnHelper = createMRTColumnHelper();

  const columns = useMemo(
    () =>
      reportDataKey.map((key) =>
        columnHelper.accessor(key, {
          header: key,
          Cell: ({ cell }) => {
            if (
              key === "number_of_event" ||
              key === "number_of_stalls" ||
              key === "number_of_dignitaries" ||
              key === "number_of_m2m" ||
              key === "filled_number_of_event_sop_checklists" ||
              key === "number_budget_invoice"
            ) {
              return (
                <span
                  style={{
                    cursor: "pointer",
                    color: "blue",
                    display: "flex",
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    inset: "0",
                    alignItems: "center",
                    padding: "20px",
                  }}
                  onClick={() => handleCellClick(cell)}
                >
                  {cell.getValue()}
                </span>
              );
            }
            return cell.getValue();
          },
        })
      ),
    [reportDataKey, columnHelper]
  );

  const handleCellClick = (cell) => {
    const columnId = cell.column.id;
    const rowData = cell.row.original;

    if (
      columnId === "number_of_event" ||
      columnId === "number_of_stalls" ||
      columnId === "number_of_dignitaries" ||
      columnId === "number_of_m2m" ||
      columnId === "filled_number_of_event_sop_checklists" ||
      columnId === "number_budget_invoice"
    ) {
      let type;
      switch (columnId) {
        case "number_of_event":
          type = "events";
          break;
        case "number_of_stalls":
          type = "stalls";
          break;
        case "number_of_dignitaries":
          type = "vgmDegnitaries";
          break;
        case "number_of_m2m":
          type = "vgmMm2m";
          break;
        case "filled_number_of_event_sop_checklists":
          type = "vgmEventSopChecklists";
          break;
        case "number_budget_invoice":
          type = "vgmInvoice";
          break;
        default:
          type = ""; // Fallback in case of unexpected columnId
      }
      setModalData({
        userId: rowData.user_id,
        type: type,
      });
      setModalOpen(true);
      // console.log(`Clicked on ${columnId}: ${cell.getValue()}`);
    }
  };

  const csvConfig = mkConfig({
    fieldSeparator: ",",
    decimalSeparator: ".",
    useKeysAsHeaders: true,
  });

  const handleExportRows = (rows) => {
    let rowData = rows.map((row) => row.original);
    const csv = generateCsv(csvConfig)(rowData);
    download(csvConfig)(csv);
  };

  const handleExportData = () => {
    const csv = generateCsv(csvConfig)(data);
    download(csvConfig)(csv);
  };

  const table = useMaterialReactTable({
    columns,
    data,
    enableRowSelection: true,
    columnFilterDisplayMode: "popover",
    paginationDisplayMode: "pages",
    positionToolbarAlertBanner: "bottom",
    initialState: {
      pagination: {
        pageSize: 5,
      },
    },
    renderTopToolbarCustomActions: ({ table }) => (
      <Box
        sx={{
          display: "flex",
          gap: "16px",
          padding: "8px",
          flexWrap: "wrap",
        }}
      >
        <Button onClick={handleExportData} startIcon={<FileDownloadIcon />}>
          Export All Data
        </Button>
        <Button
          disabled={table.getPrePaginationRowModel().rows.length === 0}
          onClick={() =>
            handleExportRows(table.getPrePaginationRowModel().rows)
          }
          startIcon={<FileDownloadIcon />}
        >
          Export All Rows
        </Button>
        <Button
          disabled={table.getRowModel().rows.length === 0}
          onClick={() => handleExportRows(table.getRowModel().rows)}
          startIcon={<FileDownloadIcon />}
        >
          Export Page Rows
        </Button>
        <Button
          disabled={
            !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
          }
          onClick={() => handleExportRows(table.getSelectedRowModel().rows)}
          startIcon={<FileDownloadIcon />}
        >
          Export Selected Rows
        </Button>
      </Box>
    ),
  });

  return (
    <>
      <Breadcrumb data="VGM report" />
      <div className="content-body">
        <div className="table-data">
          <MaterialReactTable table={table} />
        </div>
        {modalOpen && modalData && (
          <VGMReportDetailsAPI
            branchId={modalData.userId}
            columnId={modalData.type}
            modalOpen={modalOpen}
            setModalOpen={setModalOpen}
          />
        )}
      </div>
    </>
  );
}

export default VGMReport;
